export const getLastItem = <T>(list: readonly T[] | null | undefined, offsetFromEnd = 0): T | undefined => {
  return list?.[list.length - 1 - offsetFromEnd];
};
